/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_QuestionInputs */

const en_interview_attendance_question = /** @type {(inputs: Interview_Attendance_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did the interview take place?`)
};

const de_interview_attendance_question = /** @type {(inputs: Interview_Attendance_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat das Vorstellungsgespräch stattgefunden?`)
};

/**
* | output |
* | --- |
* | "Did the interview take place?" |
*
* @param {Interview_Attendance_QuestionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_question = /** @type {((inputs?: Interview_Attendance_QuestionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_QuestionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_question(inputs)
	return en_interview_attendance_question(inputs)
});